import { defineMessages } from 'react-intl';

export const jsmPortalPlaygroundHrMessages = defineMessages({
	breadcrumbSpaces: {
		id: 'JsmPortalPlayground.hr.breadcrumbSpaces',
		defaultMessage: 'Spaces',
	},
	breadcrumbSpace: {
		id: 'JsmPortalPlayground.hr.breadcrumbSpace',
		defaultMessage: 'Vitafleet HR',
	},
	breadcrumbSurveys: {
		id: 'JsmPortalPlayground.hr.breadcrumbSurveys',
		defaultMessage: 'Surveys',
	},
	surveyTitle: {
		id: 'JsmPortalPlayground.hr.surveyTitle',
		defaultMessage: 'Onboarding survey',
	},
	statusActive: {
		id: 'JsmPortalPlayground.hr.statusActive',
		defaultMessage: 'Active',
	},
	copyLink: {
		id: 'JsmPortalPlayground.hr.copyLink',
		defaultMessage: 'Copy link',
	},
	edit: {
		id: 'JsmPortalPlayground.hr.edit',
		defaultMessage: 'Edit',
	},
	moreActions: {
		id: 'JsmPortalPlayground.hr.moreActions',
		defaultMessage: 'More actions',
	},
	tabSummary: {
		id: 'JsmPortalPlayground.hr.tabSummary',
		defaultMessage: 'Summary',
	},
	tabResponses: {
		id: 'JsmPortalPlayground.hr.tabResponses',
		defaultMessage: 'Responses',
	},
	statViews: {
		id: 'JsmPortalPlayground.hr.statViews',
		defaultMessage: '{count, number} views',
	},
	statResponses: {
		id: 'JsmPortalPlayground.hr.statResponses',
		defaultMessage: '{count, number} responses',
	},
	statCompletion: {
		id: 'JsmPortalPlayground.hr.statCompletion',
		defaultMessage: '{rate, number, percent} completion',
	},
	statSince: {
		id: 'JsmPortalPlayground.hr.statSince',
		defaultMessage: 'since 2nd Oct',
	},
	questionSummaries: {
		id: 'JsmPortalPlayground.hr.questionSummaries',
		defaultMessage: 'Question summaries',
	},
	exportResponses: {
		id: 'JsmPortalPlayground.hr.exportResponses',
		defaultMessage: 'Export responses',
	},
	questionOne: {
		id: 'JsmPortalPlayground.hr.questionOne',
		defaultMessage: 'How satisfied are you with the first onboarding session?',
	},
	questionTwo: {
		id: 'JsmPortalPlayground.hr.questionTwo',
		defaultMessage: 'What aspects of your job do you find most rewarding?',
	},
	questionTwoCardTitle: {
		id: 'JsmPortalPlayground.hr.questionTwoCardTitle',
		defaultMessage: 'Q2: {question}',
	},
	responseCount: {
		id: 'JsmPortalPlayground.hr.responseCount',
		defaultMessage: '{count, number} responses',
	},
	insights: {
		id: 'JsmPortalPlayground.hr.insights',
		defaultMessage: 'Insights',
	},
	resultsViewLabel: {
		id: 'JsmPortalPlayground.hr.resultsViewLabel',
		defaultMessage: 'Results view',
	},
	showChart: {
		id: 'JsmPortalPlayground.hr.showChart',
		defaultMessage: 'Show chart',
	},
	showTable: {
		id: 'JsmPortalPlayground.hr.showTable',
		defaultMessage: 'Show table',
	},
	chartLabel: {
		id: 'JsmPortalPlayground.hr.chartLabel',
		defaultMessage: 'Bar chart of responses: {data}',
	},
	chartDatum: {
		id: 'JsmPortalPlayground.hr.chartDatum',
		defaultMessage: '{choice} {count, number}',
	},
	choiceVeryDissatisfied: {
		id: 'JsmPortalPlayground.hr.choiceVeryDissatisfied',
		defaultMessage: 'Very dissatisfied',
	},
	choiceDissatisfied: {
		id: 'JsmPortalPlayground.hr.choiceDissatisfied',
		defaultMessage: 'Dissatisfied',
	},
	choiceNeutral: {
		id: 'JsmPortalPlayground.hr.choiceNeutral',
		defaultMessage: 'Neutral',
	},
	choiceSatisfied: {
		id: 'JsmPortalPlayground.hr.choiceSatisfied',
		defaultMessage: 'Satisfied',
	},
	choiceVerySatisfied: {
		id: 'JsmPortalPlayground.hr.choiceVerySatisfied',
		defaultMessage: 'Very satisfied',
	},
	choiceTableCaption: {
		id: 'JsmPortalPlayground.hr.choiceTableCaption',
		defaultMessage: 'Responses by choice',
	},
	columnChoice: {
		id: 'JsmPortalPlayground.hr.columnChoice',
		defaultMessage: 'Choice',
	},
	columnResponses: {
		id: 'JsmPortalPlayground.hr.columnResponses',
		defaultMessage: 'Responses',
	},
	columnPercentages: {
		id: 'JsmPortalPlayground.hr.columnPercentages',
		defaultMessage: 'Percentages',
	},
	searchResponses: {
		id: 'JsmPortalPlayground.hr.searchResponses',
		defaultMessage: 'Search responses',
	},
	responsesTableCaption: {
		id: 'JsmPortalPlayground.hr.responsesTableCaption',
		defaultMessage: 'Survey responses',
	},
	columnRespondent: {
		id: 'JsmPortalPlayground.hr.columnRespondent',
		defaultMessage: 'Respondent',
	},
	columnSubmitted: {
		id: 'JsmPortalPlayground.hr.columnSubmitted',
		defaultMessage: 'Submitted',
	},
	openResponse: {
		id: 'JsmPortalPlayground.hr.openResponse',
		defaultMessage: "Open {name}'s response",
	},
	closeResponse: {
		id: 'JsmPortalPlayground.hr.closeResponse',
		defaultMessage: "Close {name}'s response",
	},
	responsePanelLabel: {
		id: 'JsmPortalPlayground.hr.responsePanelLabel',
		defaultMessage: "{name}'s survey response",
	},
	surveyResponse: {
		id: 'JsmPortalPlayground.hr.surveyResponse',
		defaultMessage: 'Survey response',
	},
	expandResponse: {
		id: 'JsmPortalPlayground.hr.expandResponse',
		defaultMessage: 'Expand response',
	},
	closeResponsePanel: {
		id: 'JsmPortalPlayground.hr.closeResponsePanel',
		defaultMessage: 'Close response',
	},
	questionOneShort: {
		id: 'JsmPortalPlayground.hr.questionOneShort',
		defaultMessage: 'Q1',
	},
	questionTwoShort: {
		id: 'JsmPortalPlayground.hr.questionTwoShort',
		defaultMessage: 'Q2',
	},
	closeInsights: {
		id: 'JsmPortalPlayground.hr.closeInsights',
		defaultMessage: 'Close insights',
	},
	rovoThinking: {
		id: 'JsmPortalPlayground.hr.rovoThinking',
		defaultMessage: 'Rovo is thinking',
	},
	usesAi: {
		id: 'JsmPortalPlayground.hr.usesAi',
		defaultMessage: 'Uses AI. Verify results.',
	},
	helpful: {
		id: 'JsmPortalPlayground.hr.helpful',
		defaultMessage: 'Helpful',
	},
	notHelpful: {
		id: 'JsmPortalPlayground.hr.notHelpful',
		defaultMessage: 'Not helpful',
	},
	sentimentLabel: {
		id: 'JsmPortalPlayground.hr.sentimentLabel',
		defaultMessage: 'Positive sentiment',
	},
	sentimentShare: {
		id: 'JsmPortalPlayground.hr.sentimentShare',
		defaultMessage: '{share, number, percent}',
	},
	insightSummary: {
		id: 'JsmPortalPlayground.hr.insightSummary',
		defaultMessage:
			'The overall tone is welcoming and enthusiastic, but there is significant underlying frustration regarding operational friction and information density. Employees feel valued by the culture but hindered by the "technical debt" of the onboarding process.',
	},
	topThemes: {
		id: 'JsmPortalPlayground.hr.topThemes',
		defaultMessage: 'Top themes',
	},
	themeTechnicalReadiness: {
		id: 'JsmPortalPlayground.hr.themeTechnicalReadiness',
		defaultMessage: 'Technical readiness & access',
	},
	themeDocumentation: {
		id: 'JsmPortalPlayground.hr.themeDocumentation',
		defaultMessage: 'Documentation quality',
	},
	themeMentorship: {
		id: 'JsmPortalPlayground.hr.themeMentorship',
		defaultMessage: 'Social & mentorship integration',
	},
	responsePriyaRewarding: {
		id: 'JsmPortalPlayground.hr.responsePriyaRewarding',
		defaultMessage: 'Pairing with my buddy in week one, I shipped something real on day three.',
	},
	responseRaulRewarding: {
		id: 'JsmPortalPlayground.hr.responseRaulRewarding',
		defaultMessage:
			'The team is genuinely welcoming, but laptop access took most of my first week.',
	},
	responseOliviaRewarding: {
		id: 'JsmPortalPlayground.hr.responseOliviaRewarding',
		defaultMessage: 'Solving customer problems. The onboarding docs were out of date though.',
	},
	responseLiamRewarding: {
		id: 'JsmPortalPlayground.hr.responseLiamRewarding',
		defaultMessage: 'Seeing how much autonomy I have this early on.',
	},
});

/** The English summary, used to time the typing animation and in tests. */
export const INSIGHT_SUMMARY_TEXT = String(
	jsmPortalPlaygroundHrMessages.insightSummary.defaultMessage,
);
